import { logger } from '@gem/modules/logger';

import { buildModelError } from 'APP/model/error/errorBuilder';
import {
  getCalendarIntegrationEnabledRequest,
  getE2eeIntegrationEnabledRequest,
} from 'APP/wsApi/wsAppApi/requests/featuresRequests';

export async function getCalendarIntegrationEnabled(): Promise<boolean> {
  try {
    const result = await getCalendarIntegrationEnabledRequest({});

    if (result.type.case === 'success') {
      return result.type.value?.isEnabled;
    }

    throw result.type.value;
  } catch (error) {
    logger.get('API').error('features.getCalendarIntegrationEnabled', error);
    throw buildModelError(error);
  }
}

export async function getE2eeIntegrationEnabled(): Promise<boolean> {
  try {
    const result = await getE2eeIntegrationEnabledRequest({});

    if (result.type.case === 'success') {
      return result.type.value?.isEnabled;
    }

    throw result.type.value;
  } catch (error) {
    logger.get('API').error('features.getE2eeIntegrationEnabled', error);
    throw buildModelError(error);
  }
}
